

































import { Models } from '@mtap-smartcity/api';
import { 
  Component, Prop, Vue, Watch
} from 'vue-property-decorator';

interface Parameter {
  name: string,
  displayName: string,
  value: string | number,
  type: 'string' | 'number' | 'address'
}

@Component
export default class ScenarioPropertiesList extends Vue {
  @Prop(Object) readonly scenarioParameters!: Models.Scenarios.Model | null;

  @Prop(Boolean) readonly disabled!: boolean;

  isFormValid = true;

  formRules = {
    longitude: [(v) => (v >= -180 && v <= 180) || !v || 'Podaj wartość między -180 a 180'],
    latitude: [(v) => (v >= -90 && v <= 90) || !v || 'Podaj wartość między -90 a 90'],
  };

  $refs!: {
    autocomplete: any;
    latitude: any;
    longitude: any;
  };

  @Watch('scenarioParameters')
  onScenarioParametersChange() : void {
    this.$refs.autocomplete.clear();
  }

  get parameters(): Parameter[] {
    const params = this.scenarioParameters;
    if (!params) return [];
    const { location } = params;

    const longitudeValue = location ? location.coordinates[0].toString() : '';
    const latitudeValue = location ? location.coordinates[1].toString() : '';

    return [
      {
        name: 'address',
        displayName: this.$t('scenarioParameters.setAddress').toString(),
        value: '',
        type: 'address'
      },
      {
        name: 'latitude',
        displayName: this.$t('scenarioParameters.latitude').toString(),
        value: latitudeValue,
        type: 'string',
      },
      {
        name: 'longitude',
        displayName: this.$t('scenarioParameters.longitude').toString(),
        value: longitudeValue,
        type: 'string',
      },
    ];
  }

  get rules() {
    return (paramName) => this.formRules[paramName] ?? [];
  }

  suffix(propName: string) {
    let suffix = '';
    switch (propName) {
      case 'longitude':
        suffix = '';
        break;
      case 'latitude':
        suffix = '';
        break;
      default:
        break;
    }
    return suffix;
  }

  updateProperty(value, name) {
    this.$emit('update:scenarioParameters', {
      name, value
    });
  }

  onPlaceChanged(place) {
    if (place.geometry && place.geometry.location) {
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.$emit('update:scenarioParameters', {
        name: 'latitude',
        value: lat.toString()
      });
      this.$emit('update:scenarioParameters', {
        name: 'longitude',
        value: lng.toString()
      });

      this.$refs.latitude.value = lat;
      this.$refs.longitude.value = lng;
    }
  }
}
